/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async transaksi({}, payload) {
    const url = `/transaksi?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async fetch({}, payload) {
    const url = `/transaksi/laporan${payload.tipe ? `-${payload.tipe}` : ''}?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  download({}, payload) {
    const url = process.env.VUE_APP_API_URL + `/transaksi/download?${queryString(payload.params)}`;
    return url;
  },

  detail({}, payload) {
    const url = `/transaksi/${payload}`;
    return http.get(url).then(({ data }) => data);
  },
};
